import React, { ReactElement, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShellThemeProvider } from '@sede-enterprise/shell-ds-react-framework';
import dayjs from 'dayjs';
import routepaths from './router/routepaths';
import Router from './router/Router';
import { IFullState } from './types/All.type';
import { AxiosInterceptor } from './services/GenesisApi';
import getAccessTokenFromCodeRefreshToken from './utils/auth/getAccessTokenFromCodeRefreshToken';
import { userRoleActions } from './store/reducers/GenesisUser';
import { INTERVAL_TIME_60000 } from './utils/common/utils';

function App(): ReactElement {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isDark } = useSelector((state: IFullState) => state.Theme);

  //  Code to fetch the access token and user details from the refresh token
  useEffect(() => {
    const refreshAccessToken = async () => {
      const refreshToken = sessionStorage.getItem('refresh_token');
      if (!refreshToken) {
        return;
      }
      const { user, accessToken, error } =
        await getAccessTokenFromCodeRefreshToken(refreshToken);
      if (error) {
        sessionStorage.setItem('redirectPath', location.pathname);
        navigate(routepaths.login);
      } else if (user) {
        const userObj = {
          sn: user.sn,
          givenName: user.givenName,
          uid: user.uid,
          accessToken,
          mail: user.mail,
        };
        dispatch(userRoleActions.setNameAccessToken(userObj));
      }
    };

    const interval = setInterval(() => {
      const expiryTime = sessionStorage.getItem('expiry_time');
      if (expiryTime) {
        const exp = dayjs.unix(parseInt(expiryTime, 10));
        const dif = exp.diff(dayjs(), 'seconds');
        const timeDifference = 300;
        if (dif < timeDifference) {
          refreshAccessToken();
        }
      }
    }, INTERVAL_TIME_60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <ShellThemeProvider theme={isDark ? 'dark' : 'light'}>
      <AxiosInterceptor>
        <Router />
      </AxiosInterceptor>
    </ShellThemeProvider>
  );
}

export default App;
